
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  HubSpotFormBase,
} from "./hubspot-form.styled";
import { Spinner } from "@xometry/xometry_loft"
import { identifyEmail } from "../../utils/analytics"
import {
  hubspotPortalId,
  hubspotFormIdOverride,
  hubspotFormOverride,
  hubspotFormSubmitEnabled
} from "../../utils/constants";
interface IHubspotFormProps {
  hubSpotFormID: string
}

const HubSpotForm = ({ hubSpotFormID }: IHubspotFormProps) => {
  const [hubSpotFormReady, setHubSpotFormReady] = useState(false);
  const formId = hubspotFormOverride && hubspotFormIdOverride || hubSpotFormID;

  const loadHubspotForm = () => {
    if (typeof window !== "undefined" && "hbspt" in window) {
      window.hbspt.forms.create({
        portalId: hubspotPortalId,
        formId: formId,
        target: "#form-container",
      });
    } else {
      setTimeout(function () {
        loadHubspotForm();
      }, 100);
    }
  }


  // onFormSubmit and other form events require jQuery to use directly, instead 
  // of adding jQuery we can use global form events as described here
  // https://legacydocs.hubspot.com/global-form-events
  useEffect(() => {
    const formEventHandler = (event: any) => {
      if (event.data.type === 'hsFormCallback') {
        if (event.data.eventName === 'onFormReady' && event.data.id === formId) {
          setHubSpotFormReady(true);
          // disable submit button if env does not integrate with Hubspot
          if(!hubspotFormSubmitEnabled) {
            var submitButtons = document.querySelectorAll('#form-container input[type="submit"]');
            for (var i = 0; i < submitButtons.length; i++) {
              (submitButtons[i] as HTMLButtonElement).disabled = true;
            }
          }
        }
        if (event.data.eventName === 'onFormSubmit' && event.data.id === formId) {
          const email = event.data.data.find((dataField: { name: string, value: string }) => dataField.name === "email").value;
          if (email) {
            identifyEmail(email)
          }
        }
      }
    }

    window.addEventListener('message', formEventHandler);
    return () => {
      window.removeEventListener('message', formEventHandler);
    }
  }, [])


  formId && !hubSpotFormReady && loadHubspotForm();

  return (
    <>
      {!hubSpotFormReady && <Spinner />}
      <HubSpotFormBase id="form-container">
        <Helmet>
          <script
            type="text/javascript"
            src="//js.hsforms.net/forms/shell.js"
          ></script>
        </Helmet>
      </HubSpotFormBase>
    </>
  )
};

export default HubSpotForm;
